/**
 * Take a 2D array of values and create a string of CSV data
 * @param {array[]} table - A 2D array of values
 */
export const csvStringify = (table) => {
  const stringifyRow = (row) => row.map((value) => `"${value}"`).join(',');
  return table.map(stringifyRow).join('\n');
};

/**
 * Export data to a CSV file
 * @param {array[]} table - A 2D array of values
 * @param {*} name - The name for the file export, NOT including the extension
 */
export const exportCsv = (table, name = 'export') => {
  const filename = `${name}.csv`;
  const exportDataType = 'text/csv;charset=utf-8';
  const csvData = csvStringify(table);
  if (navigator.msSaveBlob) {
    // export in IE
    const blob = new Blob([csvData], { type: exportDataType });
    navigator.msSaveBlob(blob, filename);
  } else {
    // export in other browsers
    const encodedUri = `data:${exportDataType},${encodeURIComponent(csvData)}`;
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const exportFromUrl = (name, url) => {
  let link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
